/**
 * Maps shop name to display name
 * @param {string} shop - Shop name (tama, smile)
 * @returns {string} Display name
 */
const getShopDisplayName = (shop) => {
  const shopMapping = {
    'tama': 'TamaChan (ทามะจัง)',
    'smile': 'Smile NSG'
  };
  
  return shopMapping[shop?.toLowerCase()] || shop;
};

/**
 * Generates blacklist warning message in Thai
 * @param {string} shopName - Shop name (will be mapped to display name)
 * @param {string} formattedAmount - Formatted amount (e.g., "7,500")
 * @param {string} [source] - Blacklist source: 'auto' (debt) or 'manual' (permanent villain)
 * @returns {string} Formatted warning message
 */
const generateBlacklistWarningMessage = (shopName, formattedAmount, source = 'auto') => {
  const shopDisplayName = getShopDisplayName(shopName);

  // Manual (villain) entry — internal STOP order for staff, NOT for sending to the customer
  if (source === 'manual') {
    return `🚫🚫 ห้ามรับออเดอร์เด็ดขาด 🚫🚫

ลูกค้าคนนี้โดน Blacklist ถาวร (Manual)
จากร้าน ${shopDisplayName}

ห้ามขาย ห้ามรับฝากซื้อ ทุกกรณี
หากมีข้อสงสัยติดต่อหัวหน้าเท่านั้น`;
  }

  return `ต้องขออภัยด้วยครับ คุณลูกค้า

ทางเรายังไม่สามารถดำเนินการสั่งซื้อสินค้าให้คุณลูกค้าได้

เนื่องจากคุณลูกค้ามียอดค้างชำระกับเพจ ${shopDisplayName} อยู่ที่ ${formattedAmount} บาท

รบกวนคุณลูกค้าดำเนินการชำระยอดดังกล่าวก่อนครับ

ต้องขออภัยในความไม่สะดวกด้วยครับ ขอบคุณครับ`;
};

export { getShopDisplayName, generateBlacklistWarningMessage };

